import {
  EmblaButton,
  EmblaButtonNext,
  EmblaButtonPrev,
} from '@/components/Carousel/styled';
import styled, { css } from 'styled-components';

export const SavedScreenerButtonContent = styled.div`
  margin-right: ${({ theme }) => theme.x1spacePx}px;
  margin-left: ${({ theme }) => theme.x1spacePx}px;
  line-height: 1.7;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  visibility: visible;
`;

type SavedScreenerButtonProps = { isActive: boolean };

export const SavedScreenerButton = styled.button.attrs<SavedScreenerButtonProps>(
  ({ theme }) => ({
    ...theme.focus('solid'),
  })
)<SavedScreenerButtonProps>`
  height: 70px;
  padding: ${({ theme }) => theme.x1 * 1.5}px ${({ theme }) => theme.x2}px;
  background: ${({ theme }) => theme.color.brand03RGBA(0.1)};
  border-radius: ${({ theme }) => theme.x1}px;
  color: ${({ theme }) => theme.color.brand01};
  ${({ theme }) => theme.typography.xSmall};

  &:hover {
    background: ${({ theme }) => theme.color.brand03RGBA(0.2)};
  }

  ${({ isActive, theme }) =>
    isActive &&
    css`
      && {
        background: ${theme.color.brand03RGBA(0.3)};
        cursor: default;
      }
    `};
`;

export const StyledEmbla = styled('div')`
  position: relative;
  overflow: hidden;

  ${EmblaButton} {
    transition: all 0.3s ease-in-out;
    background: ${({ theme }) => theme.color.phantomRGBA(0.8)} !important;
    width: ${({ theme }) => theme.x5spacePx}px;
    height: ${({ theme }) => theme.x5spacePx}px;
    border-radius: ${({ theme }) => theme.x5spacePx}px;

    > svg > * {
      fill: ${({ theme }) => theme.color.white};
    }

    &:disabled {
      opacity: 0;
    }
  }

  ${EmblaButtonNext} {
    right: 0;

    &:disabled {
      ${({ theme }) => css`
        right: -${theme.x5spacePx}px;
      `}
    }
  }

  ${EmblaButtonPrev} {
    left: 0;

    &:disabled {
      ${({ theme }) => css`
        left: -${theme.x5spacePx}px;
      `}
    }
  }
`;
